import * as React from "react"
import type { SVGProps } from "react"

export const Playback75Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M10.875 16.75a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.32.216-.534a.73.73 0 0 1 .534-.216h2.942a.3.3 0 0 0 .222-.086.3.3 0 0 0 .086-.222v-1.884a.3.3 0 0 0-.086-.222.3.3 0 0 0-.222-.086H11.03a.88.88 0 0 1-.644-.259.88.88 0 0 1-.26-.65V8.16q0-.392.26-.65a.88.88 0 0 1 .644-.259h3.846q.319 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.534a.73.73 0 0 1-.534.216h-3.25v2.5h2.192q.758 0 1.283.525t.525 1.283v1.884q0 .758-.525 1.283t-1.283.525zm-2.75 0a.73.73 0 0 1-.535-.216.73.73 0 0 1-.215-.534q0-.32.216-.534a.73.73 0 0 1 .534-.216q.32 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215"
    ></path>
  </svg>
)
